"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    pictureInPictureSvgFill: {
        fill: function (data) { return data.color; },
    },
};
//# sourceMappingURL=picture-in-picture.theme.js.map